<template>
	<div>
		<PowerBI />
	</div>
</template>

<script>
import PowerBI from '../../../components/PowerBI/PowerBI'

export default {
	components: {
		PowerBI,
	},
}
</script>
